/** KPI card reutilizable (contenido controlado por el módulo). */
export default function KpiCard({ label, value, hint, tone, onClick, selected }) {
  const toneClass = tone ? ' is-' + tone : '';
  const clickClass = onClick ? ' is-clickable' : '';
  const selClass = selected ? ' is-selected' : '';
  const className = 'shared-kpi-card' + toneClass + clickClass + selClass;
  const body = (
    <>
      <p className="shared-kpi-label">{label}</p>
      <p className="shared-kpi-value">{value}</p>
      {hint ? <p className="shared-kpi-hint">{hint}</p> : null}
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={className} onClick={onClick}>
        {body}
      </button>
    );
  }
  return <article className={className}>{body}</article>;
}
